import throttle from 'lodash/throttle';
import { autorun } from 'mobx';
import { getStore } from './stores';

//global
const state = {
	initialized: false,
};

const classes = {
	navCaw: 'NavigationCAW',
	trigger: 'CAW-trigger',
	calRow: 'Calendar-row',
	hideBtn: 'hideButton',
	hasEliteGuestComponent: 'hasEliteGuestComponent',
	checkRatesCtaCawTrigger: `CheckRates-cta-caw-trigger`,
	checkRatesCtaDefaultTrigger: `default-trigger`,
};
const $window = $(window);

const checkRatesCtaCawTrigger = async () => {
	const planStore = await getStore('planStore');
	autorun(async () => {
		if (planStore?.fetching === false) {
			const embeddedBookingEnabled = await planStore.embeddedBookingEnabled();
			if (embeddedBookingEnabled) {
				$('body').on('click', `.${classes.checkRatesCtaCawTrigger}`, event => {
					event.preventDefault();
					window.FS.Tealium.trackInteraction(
						'integrated booking engine',
						'check rates',
						'body'
					);
					window.dispatchEvent(
						new CustomEvent('cawComponentOpen', { detail: { setFocusTo: 'dates' } })
					);
				});
			} else {
				$('body').on(
					'click',
					`.${classes.checkRatesCtaCawTrigger}.${classes.checkRatesCtaDefaultTrigger}`,
					event => {
						event.preventDefault();
						window.FS.Tealium.trackInteraction(
							'integrated booking engine',
							'check rates',
							'body'
						);
						window.dispatchEvent(new Event('cawComponentOpen'));
					}
				);
			}
		}
	});
};

export default function checkAvailabilityWidget() {
	let init = () => {
		if (!state.initialized) {
			state.initialized = true;

			const $navCaw = $(`.${classes.navCaw}`);
			const $hideBtn = $(`.${classes.hideBtn}`);

			let closeOnScroll = true;

			//we want to delay this until other js is done as otherwise the animate is too laggy or won't be visible
			setTimeout(() => {
				$('body').on('click', `.${classes.trigger}`, event => {
					if (window.outerWidth >= '1100' && $navCaw.length) {
						event.preventDefault();
						window.FS.Tealium.trackInteraction(
							'integrated booking engine',
							'check rates',
							'global nav header'
						);
						event.stopImmediatePropagation();
						openClose(false, false, event.target);
					}
				});
				// Check if we are on internal properties page
				const shouldOpenAutomatically = $navCaw.hasClass('NavigationCAW--open');
				// show the CAW if the user hasn't manually closed it this session
				if (!sessionStorage.getItem('userClosedPopupCaw') && shouldOpenAutomatically) {
					openClose(false, true);
				}
				let lastScrollTop = $window.scrollTop();
				const handleScroll = throttle(() => {
					const st = $window.scrollTop();
					if (st > lastScrollTop) {
						// downscroll
						closeOnScroll = true;
					}
					lastScrollTop = st;
					const $calRow = $(`.${classes.calRow}`);
					if ($calRow.length) {
						if (!$calRow.first().hasClass('hideCaw')) {
							closeOnScroll = false;
						}
					}
					if (closeOnScroll) {
						openClose(true);
					}
				}, 5);
				$(window).scroll(handleScroll);
			});

			checkRatesCtaCawTrigger();

			window.addEventListener('cawComponentClose', () => {
				openClose(true);
				sessionStorage.setItem('userClosedPopupCaw', 1);
			});
			window.addEventListener('cawComponentOpen', event => {
				openClose(false, true);
				if (event?.detail?.setFocusTo === 'dates') {
					$('.Calendar-container .DateField').click();
				}
			});
			$('.InlineCarousel-prevButton, .InlineCarousel-nextButton').on('click', () => {
				openClose(true);
			});

			const openClose = (closeOnly, openOnly, element) => {
				const cawTrigger = $(element);
				const propertyCode = cawTrigger.data('caw-property-codes');
				if (propertyCode) {
					$navCaw.find('#destination-id').val(propertyCode);
				}
				const $cawButton = $(`.${classes.trigger}`);
				$hideBtn.attr('aria-controls', 'NavigationCAW');
				$cawButton.attr('aria-controls', 'NavigationCAW');
				if (
					!openOnly &&
					!propertyCode &&
					$navCaw.is(':visible') &&
					$navCaw.queue().length === 0
				) {
					$navCaw.slideUp({
						duration: 200,
					});
					$cawButton.finish();
					$cawButton.css('visibility', '');
					$cawButton.fadeTo(200, 1);
					$cawButton.attr('aria-expanded', 'false');
					$hideBtn.attr('aria-expanded', 'false');
					$navCaw.parents('nav').removeClass('caw-open');
				} else if (!closeOnly) {
					$navCaw.slideDown({
						duration: 200,
					});
					$cawButton.finish();
					$cawButton.fadeTo(200, 0, () => {
						$cawButton.css('visibility', 'hidden');
					});
					$cawButton.attr('aria-expanded', 'true');
					$hideBtn.attr('aria-expanded', 'true');
					$navCaw.parents('nav').addClass('caw-open');

					if ($window.scrollTop() < 200) {
						setTimeout(() => {
							$('.cawComponent').focus();
						}, 200);
					}
				}
				closeOnScroll = false;
			};
		}
	};

	if (window.cawComponentLoaded) {
		init();
	} else {
		window.addEventListener('cawComponentLoaded', () => {
			init();
		});
	}
}
